import { createRequest } from '@savgroup-front-common/core/services/request';

export const GET_DOCUMENTS_BY_CLAIM_ID = createRequest(
  'CLAIMS/GET_DOCUMENTS_BY_CLAIM_ID',
);
